const featureFlaggedPaths = {
  '/admin/credit': 'CREDIT_TOOL',
  '/customer/amd': 'PATIENT_LINKING',
  '/admin/product': 'PRODUCT_TOOL'
};

export const setFeatureFlags = flags => {
  localStorage.setItem('FEATURE_FLAGS', JSON.stringify(flags));
};

export function checkFeatureFlag(flag: string): boolean {
  const featureFlags = localStorage.getItem('FEATURE_FLAGS');
  if (featureFlags) {
    const flags = JSON.parse(featureFlags);
    return flags[flag];
  }
  return false;
}

export function checkPathFeatureFlag(pathname: string): boolean {
  for (const [path, flag] of Object.entries(featureFlaggedPaths)) {
    if (pathname.includes(path)) {
      return checkFeatureFlag(flag);
    }
  }
  return true;
}
